module.exports = __webpack_public_path__ + "static/media/paginate-first-page.f8eb70de.svg";